{% block sw_customer_detail_content_tab_order %}
    {% parent() %}

    <sw-tabs-item
        class="sw-customer-detail__tab-neti-incomplete-order-reminder"
        :route="iorOpenCartsRoute"
        :title="$t('neti-incomplete-order-reminder.customer.detail.tabTitle')"
    >
        {{ $t('neti-incomplete-order-reminder.customer.detail.tabTitle') }}
    </sw-tabs-item>
{% endblock %}